export default __webpack_public_path__ + "static/blob5-1ecb9c9f37522ba506f7c18bfcf998ed.svg";